export const projectRouteName = {
  index: "projects.index",
};

export const projectRoute = [
  {
    path: "/projects",
    name: projectRouteName.index,
    component: () => import("../pages/DataTablePage.vue"),
    meta: {
      requiresAuth: true,
      layout: "adminSidebar",
      menu: "client_project",
      breadcrumbs: () => {
        return [{ title: "Project" }];
      },
    },
  },
];
